import type { IssueDto } from '@aiai/shared';
import { TERMINAL_RUN_STATUSES } from '@aiai/shared';

/**
 * True while the issue's latest run is still in flight — the only "active
 * run" signal available here (in practice this coincides with `state ===
 * 'building'`, but is derived from the run status directly).
 */
export function hasActiveRun(issue: IssueDto): boolean {
  return !!issue.latestRun && !TERMINAL_RUN_STATUSES.includes(issue.latestRun.status);
}
